// extracted by mini-css-extract-plugin
export default {"removeBtn":"NWBKfD"};